import { useLinkProps } from './hooks';
import * as Styled from './MenuLink.styles';
import { isRouterLinkProps } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function MenuLink({
  children,
  ...restProps
}) {
  const linkProps = useLinkProps(restProps);
  if (isRouterLinkProps(linkProps)) {
    return /*#__PURE__*/_jsx(Styled.Link, {
      ...linkProps,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Styled.Link, {
    as: "a",
    ...linkProps,
    children: children
  });
}